<div class="main-container">

  <div class="title">
    <span class="title-text">Block a Day</span>
    <p class="small-title">Block accommodation booking for a specific day.</p>
  </div>

  @if(canBlock){
  <div class="block-form">
    <input type="date" class="text-box-active" [formControl]="date" />
    <button type="button" class="ac-danger-btn" (click)="block()">Block day</button>
  </div>
  }

  <div class="section-title">Blocked days</div>
  @if(blockedDays.length){
  <div class="chips">
    @for(day of blockedDays; track day){
    <div class="chip">
      <span>{{ day }}</span>
      @if(canBlock){
      <button type="button" class="chip-x" (click)="unblock(day)" title="Unblock">×</button>
      }
    </div>
    }
  </div>
  } @else {
  <p class="empty">No days are currently blocked.</p>
  }

</div>

<app-loader [isLoading]="isLoading"></app-loader>
